
import { postFormData } from './fetch';
import API from './api';

/**
 * 切换字号
 * @param  {string} fontSize 字号
 */
export function changeFontSize(fontSize: string) {
    const formData = new FormData();
    formData.append('option_type', '16');
    formData.append('option_value', fontSize);

    return postFormData(API.CHANGE_FONT_SIZE.url, formData);
}
